import React from "react";
import { MapPin, Navigation } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurGlobalPresence() {
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll();
  return;
}